var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    _vm.$style.wrap,
    ( _obj = {}, _obj[_vm.$style.center] = _vm.center, _obj[_vm.$style.right] = _vm.right, _obj[_vm.$style.stacked] = _vm.stacked, _obj ) ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }